import React, { useEffect } from "react";

export default function Container({ children, containerClassName }) {
    useEffect(() => {
        const containerSection = document.querySelector(".container-rifa:not(.list)");
        containerSection && containerSection.classList.add("shown");
        containerSection && containerSection.offsetHeight;


        return () => {
            containerSection && containerSection.classList.remove("shown");
            containerSection && containerSection.offsetHeight;
        }
    }, []);

    return <section className="content-rifa">
        <section className={`container-rifa ${containerClassName}`}>
            { children }
        </section>
    </section>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/container.jsx